// Radiation Absorbed Dose units with conversion factors to gray (Gy)
export const radiationAbsorbedDoseUnits = [
  { id: 'gray', name: 'Gray', symbol: 'Gy', plural: 'Grays', factor: 1 },
  { id: 'milligray', name: 'Milligray', symbol: 'mGy', plural: 'Milligrays', factor: 1e-3 },
  { id: 'microgray', name: 'Microgray', symbol: 'µGy', plural: 'Micrograys', factor: 1e-6 },
  { id: 'rad', name: 'Rad', symbol: 'rad', plural: 'Rads', factor: 0.01 },
  { id: 'millirad', name: 'Millirad', symbol: 'mrad', plural: 'Millirads', factor: 1e-5 },
  { id: 'joule-per-kilogram', name: 'Joule/Kilogram', symbol: 'J/kg', plural: 'Joules/Kilogram', factor: 1 },
  { id: 'joule-per-gram', name: 'Joule/Gram', symbol: 'J/g', plural: 'Joules/Gram', factor: 1e3 },
  { id: 'joule-per-centigram', name: 'Joule/Centigram', symbol: 'J/cg', plural: 'Joules/Centigram', factor: 1e5 },
  { id: 'joule-per-milligram', name: 'Joule/Milligram', symbol: 'J/mg', plural: 'Joules/Milligram', factor: 1e6 },
  { id: 'erg-per-gram', name: 'Erg/Gram', symbol: 'erg/g', plural: 'Ergs/Gram', factor: 1e-4 },
];

export const popularRadiationAbsorbedDoseConversions = [
  { from: 'gray', to: 'rad' },
  { from: 'rad', to: 'gray' },
  { from: 'gray', to: 'milligray' },
  { from: 'milligray', to: 'microgray' },
  { from: 'gray', to: 'joule-per-kilogram' },
  { from: 'rad', to: 'millirad' },
];

export const getUnitById = (id) => radiationAbsorbedDoseUnits.find(unit => unit.id === id);

export const convertRadiationAbsorbedDose = (value, fromId, toId) => {
  const fromUnit = getUnitById(fromId);
  const toUnit = getUnitById(toId);
  if (!fromUnit || !toUnit) return null;
  const baseValue = value * fromUnit.factor;
  return baseValue / toUnit.factor;
};

export const formatConversionTitle = (fromUnit, toUnit) => {
  return `Convert ${fromUnit.plural} to ${toUnit.plural}`;
};

export const generateSEODescription = (fromUnit, toUnit) => {
  return `Free online ${fromUnit.name} to ${toUnit.name} converter. Instantly convert radiation absorbed dose units and learn the conversion formula.`;
};
